export const IS_PROD = false;

export const API_URL = "https://bc-pos-server-202728687577.us-central1.run.app"; // "http://localhost:8080"; //

export const DRAWER_WIDTH = 260;

export const MAX_IMAGES = 5;

export const MIN_TIME_STATIONS = 15 * 60;

export const defaultCustomerConfig = {
  department: "ANTIOQUIA",
  departmentId: "5",
  city: "COPACABANA",
  cityId: "05212",
  neighborhood: "COPACABANA",
  address: "-",
  email: "cliente@bcpos.com",
  phone: "0000000",
};

export const UNITS = [
  { id: "UNIT", name: "Unidades" },
  { id: "GR", name: "Gramos" },
  { id: "LT", name: "Litros" },
];

export const quickReasons = [
  "Error al ingresar producto",
  "Producto equivocado",
  "Cliente cambió el pedido",
  "Producto duplicado",
  "Corrección de precio",
];
